import { apiService } from './apiService';

export const paymentsApi = {
    // Create a Stripe Checkout Session (for hosted payment page)
    createCheckoutSession: async (notes?: any , data? : any) => {
        try {
            return await apiService.post('/payments/create-checkout-session', { notes  , data});
        } catch (error) {
            throw error;
        }
    },

    // Create a payment intent
    createPaymentIntent: async (paymentData: any) => {
        try {
            return await apiService.post('/payments/create-payment-intent', paymentData);
        } catch (error) {
            throw error;
        }
    },

    // Get payment status
    getPaymentStatus: async (orderId: string) => {
        try {
            return await apiService.get(`/payments/status/${orderId}`);
        } catch (error) {
            throw error;
        }
    },

    // Verify checkout session and complete order
    verifyCheckoutSession: async (sessionId: string) => {
        try {
            // Use longer timeout for verification as it may send emails
            return await apiService.get(`/payments/verify-session/${sessionId}`, {
                timeout: 120000, // 30 seconds
            });
        } catch (error) {
            throw error;
        }
    },

    // Handle Stripe webhook
    handleWebhook: async (webhookData: any) => {
        try {
            return await apiService.post('/payments/webhook', webhookData);
        } catch (error) {
            throw error;
        }
    },
};